import { gql } from "@apollo/client";

export const GET_COMENTARIOS = gql`
    query envioComentarios (
        $idDelegacion: Int!
        $idPaciente: Int!
    ){
        envioComentarios (
            idDelegacion: $idDelegacion
            idPaciente: $idPaciente
        ){
            usuario
            fecha
            comentario
        }
    }
`;